import * as pdfjs from 'pdfjs-dist/legacy/build/pdf'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import shortId from 'shortid';
import { Observable } from 'rxjs';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const renderPage = async (container, pdf, pageNumber) => {
    const canvas = document.createElement('canvas');
    canvas.hidden = true;
    canvas.className = 'canvas';
    container.appendChild(canvas);

    const page = await pdf.getPage(pageNumber);
    const scale = 2;
    const viewport = page.getViewport({scale: scale});

    const context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
        canvasContext: context,
        viewport: viewport
    };

    const renderTask = page.render(renderContext);
    await renderTask.promise;

    return canvas
};

export const renderPDF = (file, firstPageOnly=false, includeTotal=false, batchSubscriber=null, batchSize=10) => {
    return new Observable(subscriber => {
        try {
            const container = document.createElement('div');
            const id = shortId.generate()
            container.setAttribute('id', id)    
            pdfjs.getDocument(file).promise.then(async pdf => {
                let page
                const numPages = firstPageOnly ? 1 : pdf.numPages
                const firstBatch = numPages < batchSize ? numPages : batchSize
                if (batchSubscriber) {
                    // Always load the first batch
                    for (let i = 1; i <= firstBatch; i++) {
                        page = await renderPage(container, pdf, i);

                        subscriber.next(includeTotal
                            ? {total: numPages, page: page.toDataURL()}
                            : page.toDataURL())
                    }

                    // Subscribe to load more batches
                    batchSubscriber.subscribe(async batch => {
                        console.log(batch)
                        let from = (batch - 1) * batchSize
                        let to = numPages < from + batchSize ? numPages : from + batchSize
                        for (let i = from + 1; i <= to; i++) {
                            page = await renderPage(container, pdf, i);
                            
                            subscriber.next(includeTotal
                                ? {total: numPages, page: page.toDataURL()}
                                : page.toDataURL())
                        }
                        if (to == numPages) {
                            subscriber.complete()
                        }
                    })
                } else {
                    for (let i = 1; i <= numPages; i++) {
                        page = await renderPage(container, pdf, i);
                        
                        subscriber.next(includeTotal
                            ? {total: numPages, page: page.toDataURL()}
                            : page.toDataURL())
                    }
                    subscriber.complete()
                }
            }).catch(fetchingError => {
                console.error('Failed to fetch pdf file with error: ', fetchingError);
                subscriber.error(fetchingError)
                subscriber.complete()
            });
        } catch (error) {
            console.error('Failed to render pdf file with error: ', error);
            subscriber.error()
            subscriber.complete()
        }
    })
};

export const downloadPDF = (fileName, fileURL) => {
    let link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.dispatchEvent(new MouseEvent('click'));
};